__turbopack_context__.v({
  "accent": "VoiceItem-module-scss-module__kdScGa__accent",
  "avatar": "VoiceItem-module-scss-module__kdScGa__avatar",
  "avatar-wrapper": "VoiceItem-module-scss-module__kdScGa__avatar-wrapper",
  "container": "VoiceItem-module-scss-module__kdScGa__container",
  "label": "VoiceItem-module-scss-module__kdScGa__label",
  "play": "VoiceItem-module-scss-module__kdScGa__play",
  "selected": "VoiceItem-module-scss-module__kdScGa__selected",
  "sub-label": "VoiceItem-module-scss-module__kdScGa__sub-label",
  "wrapper": "VoiceItem-module-scss-module__kdScGa__wrapper",
});
